<template>
    <div>
        <b-button class="button is-primary next-button rolltext-button" @click="nextStep()">
            <Transition name="slide-up"   @before-enter="onBeforeEnter"  @enter="onEnter"  @leave="onLeave" >
                    <span v-if="docState === 'first-line'" key="first-line" v-html="firstline"></span>
                <span v-else-if="docState === 'second-line'" key="second-line" v-html="secondline"></span>
            </Transition>
        </b-button>
    </div>
</template>

<script>
import gsap from "gsap";
import mixin from "../../components/form/steps/travel_step_mixin";


export default {
    mixins: [mixin],
    props:{
        firstline:{
            type:String,
            default:'Vraag je pakket aan',
        },
        secondline:{
            type:String,
            default:'Grijp het aanbod',
        },
    },
    data() {
        return {
            docState: 'first-line',
            stateCycle: ['first-line','second-line'],
            stateInterval: null
        };
    },
    methods: {
        startStateCycle() {
            if (this.stateInterval) return;
            this.stateInterval = setInterval(() => {
                const idx = this.stateCycle.indexOf(this.docState);
                this.docState = this.stateCycle[(idx + 1) % this.stateCycle.length];
            }, 2000);},
        stopStateCycle() {
            clearInterval(this.stateInterval);
            this.stateInterval = null;
        },
        onBeforeEnter(el) {
            gsap.set(el, { opacity: 0, y: -50 });
        },
        onEnter(el, done) {
            gsap.to(el, { opacity: 1, y: 0, duration: 0.5, onComplete: done });
        },
        onLeave(el, done) {
            gsap.to(el, { opacity: 0, y: -50, duration: 0.5, onComplete: done });
        }
        },
    mounted() {
        this.startStateCycle();
    },
    beforeUnmount() {
        this.stopStateCycle();
    },
    computed: {
        formUrl() {
            return `${location.origin}/${window.slug}`
        },
        isMobile() {
            return window.innerWidth <= 768;
        }
    }
};
</script>

